import DropIntroScreen from './scenes/DropIntroScreen';
import GameScreen from './scenes/GameScreen';
import IntroScreen from './scenes/IntroScreen';
import MarbleDrop from './scenes/MarbleDrop';
import MarbleDropResults from './scenes/MarbleDropResults';
import ResultsScreen from './scenes/ResultsScreen';
import RoundSelectScreen from './scenes/RoundSelectScreen';

export const MATH_MODE = 'MATH';
export const MATH_MODE_GAME_NAME = 'Marble Math Addition';
export const MATH_MODE_SHORTNAME = 'addition';
export const DROP_MODE = 'DROP';
export const DROP_MODE_GAME_NAME = 'Marble Drop Addition';
export const DROP_MODE_SHORTNAME = 'marble_drop_addition';

export default {
  /**
     * Add your scene classes here. Simply put the scene class.
     * Ex: `scenes: [MyScene,MyOtherScene]`
     * @type {{KEY:string}[]}
     */
  scenes: [],
  mathScenes: [IntroScreen, RoundSelectScreen, GameScreen, ResultsScreen, MarbleDrop, MarbleDropResults],
  dropScenes: [DropIntroScreen, MarbleDrop, MarbleDropResults],

  /**
     * Set the first scene that should be loaded here. Must match one of the scenes' key found in the scenes array.
     * It is recommended you put `MyScene.KEY` here instead of using a string.
     * @type {string}
     */
  startScene: '',
  mathStartScene: IntroScreen.KEY,
  dropStartScene: DropIntroScreen.KEY,

  GAME_MODE: MATH_MODE, // can be MATH_MODE or DROP_MODE

  ROUND_QUESTION_COUNT: 10,

  MARBLE_SPAWNTIME: 2845,
  MARBLE_SPEED: 40,
  MAX_MARBLE_VALUE: 10,

  KEY_LEFT: 'key_left',
  KEY_RIGHT: 'key_right',
  CONTROL_TYPE: 'keys',
};
